import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: 8,
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 4,
  gap: 8,
  '& > .MuiBox-root.header': {
    display: 'flex',
    gap: 4,
    justifyContent: 'space-between',
    '& > .MuiTypography-subtitle1': {
      color: spaceCadet[400],
      fontWeight: 600,
      textTransform: 'uppercase',
      lineHeight: '24px',
      fontSize: 14,
    },
    '& > .MuiChip-root': {
      height: 20,
      color: 'white',
      alignSelf: 'flex-start',
      fontWeight: 600,
      fontStyle: 'italic',
    },
  },
  '& > .compliance-module-topics': {
    display: 'flex',
    flexDirection: 'column',
    '& > .MuiBox-root': {
      margin: '0px -8px',
      padding: '8px 8px',
      '&:nth-of-type(odd)': {
        backgroundColor: spaceCadet[100],
      },
    },
  },
  '& .MuiBox-root.mandatory-topics': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& .MuiTypography-h6': {
      fontWeight: 600,
      fontSize: 14,
    },
    '& > .MuiBox-root.header': {
      display: 'flex',
      gap: 4,
      alignItems: 'center',
      '& > .MuiTypography-subtitle2': {
        color: spaceCadet[400],
        fontWeight: 700,
        fontSize: 12,
      },
    },
  },
  '& .MuiBox-root.compliance-content': {
    display: 'flex',
    gap: 8,
    flexDirection: 'row',
    flexWrap: 'wrap',
    '& > .MuiButtonBase-root': {
      display: 'flex',
      alignItems: 'center',
      padding: 4,
      borderRadius: 4,
      border: `1px solid ${spaceCadet[300]}`,
      gap: 4,
      '& > .MuiSvgIcon-root': {
        fontSize: 16,
      },
    },
  },
});

export default StyledBox;
